import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

const MentionsLegales = () => {
  usePageMeta({
    title: "Mentions légales — B8ild",
    description: "Mentions légales du site b8ild.fr — éditeur, hébergeur, directeur de publication et informations de contact du logiciel de gestion chantier BTP.",
    url: "https://b8ild.fr/mentions-legales",
  });

  return (
    <LegalPageLayout
      title="Mentions Légales"
      subtitle="Informations légales relatives au site B8ild"
    >
      <h2>1. Éditeur du site</h2>
      <p>
        Le site B8ild accessible à l'adresse{" "}
        <a href="https://b8ild.fr" target="_blank" rel="noopener noreferrer">https://b8ild.fr</a>{" "}
        est édité par :
      </p>
      <p>
        <strong>B8ild LLC</strong>
      </p>
      <p>
        <em>Informations complémentaires en cours d'immatriculation.</em>
      </p>
      <p>
        Email : <a href="mailto:contact@b8ild.fr">contact@b8ild.fr</a>
      </p>

      <h2>2. Hébergement</h2>
      <p>Le site est hébergé par :</p>
      <p>
        <strong>Vercel Inc.</strong><br />
        340 S Lemon Ave #4133<br />
        Walnut, CA 91789, USA<br />
        <a href="https://vercel.com" target="_blank" rel="noopener noreferrer">https://vercel.com</a>
      </p>
      <p>Les données sont hébergées par :</p>
      <p>
        <strong>Supabase Inc.</strong><br />
        970 Toa Payoh North #07-04<br />
        Singapore 318992<br />
        <a href="https://supabase.com" target="_blank" rel="noopener noreferrer">https://supabase.com</a>
      </p>

      <h2>3. Propriété Intellectuelle</h2>
      <p>
        L'ensemble du contenu du site B8ild (textes, images, graphismes, logo, icônes, logiciels,
        base de données) est la propriété exclusive de B8ild et est protégé par les lois françaises
        et internationales relatives à la propriété intellectuelle.
      </p>
      <p>
        Toute reproduction, représentation, modification, publication, ou exploitation non autorisée
        est strictement interdite et constitue une contrefaçon sanctionnée par le Code de la propriété
        intellectuelle.
      </p>

      <h2>4. Données Personnelles</h2>
      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique
        et Libertés, vous disposez de droits sur vos données personnelles.
      </p>
      <p>
        Pour plus d'informations, consultez notre{" "}
        <Link to="/confidentialite">Politique de Confidentialité</Link>.
      </p>

      <h2>5. Cookies</h2>
      <p>
        Le site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques
        de visite. Pour plus d'informations sur les cookies et leur gestion, consultez notre{" "}
        <Link to="/confidentialite">Politique de Confidentialité</Link>.
      </p>

      <h2>6. Crédits</h2>
      <p>
        Conception et développement : <strong>B8ild</strong>
      </p>
      <p>
        Icônes :{" "}
        <a href="https://lucide.dev" target="_blank" rel="noopener noreferrer">Lucide Icons</a>
      </p>
      <p>
        Composants UI :{" "}
        <a href="https://ui.shadcn.com" target="_blank" rel="noopener noreferrer">shadcn/ui</a>
      </p>

      <h2>7. Contact</h2>
      <p>
        Pour toute question ou réclamation :<br />
        Email : <a href="mailto:contact@b8ild.fr">contact@b8ild.fr</a>
      </p>
    </LegalPageLayout>
  );
};

export default MentionsLegales;
